<template>
  <div class="settings-instruction" v-if="speakersPageSettings">
    <h2 class="headline">Speakers page settings</h2>
    <v-form class="form">
      <v-layout column>
        <v-card width="320">
          <div class="grey lighten-2">
            <v-card-media height="130" :src="topBannerImageUrl"/>
          </div>
          <v-card-title><h3>Image for featured session</h3></v-card-title>
          <v-card-actions>
            <v-btn flat color="success" @click="toggleModal">Choose</v-btn>
            <v-btn flat color="error"
                   :disabled="!formData.topBannerImageBackgroundId"
                   @click="resetImage">Reset
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-layout row>
          <v-card class="input">
            <content-editor
              label="Page title"
              v-model="formData.pageTitle"
              @input="$v.formData.pageTitle.$touch()"
              @blur="$v.formData.pageTitle.$touch()"
              :error="$v.formData.pageTitle"
            />
          </v-card>
          <v-card class="input">
            <content-editor
              label="Page subtitle"
              v-model="formData.pageSubtitle"
              @input="$v.formData.pageSubtitle.$touch()"
              @blur="$v.formData.pageSubtitle.$touch()"
              :error="$v.formData.pageSubtitle"
            />
          </v-card>
        </v-layout>
      </v-layout>

      <v-text-field
        class="input"
        v-model="formData.emailAddressPlaceholder"
        name="email-placeholder"
        label="Email address placeholder"
      ></v-text-field>
      <v-text-field
        class="input"
        v-model="formData.questionPlaceholder"
        name="question-placeholder"
        label="Question placeholder"
      ></v-text-field>

      <v-btn
        class="btn_submit"
        color="success"
        @click="submitForm"
        :disabled="$v.$invalid || !isWriteAvailable"
      >Update settings
      </v-btn>

    </v-form>
    <div>
      <v-dialog v-model="modalGallery">
        <galleries-list :modalView="true" @pickedImage="setImage"/>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { pathOr, path, clone } from 'ramda'
import { required } from 'vuelidate/lib/validators'
import mixins from '@/utils/mixins'
import GalleriesList from '@/components/pages/Gallery/GalleriesList'

export default {
  name: 'page-settings',
  mixins: [mixins.isWriteAvailable],
  components: {
    GalleriesList
  },
  data () {
    return {
      formData: {
        pageTitle: '',
        pageSubtitle: '',
        emailAddressPlaceholder: '',
        questionPlaceholder: '',
        topBannerImageBackgroundId: ''
      },
      topBannerChangedUrl: '',
      // DON'T DELETE! need for isWriteAvailable mixin
      scopeForWrite: 'speakers:write',
      modalGallery: false
    }
  },
  validations: {
    formData: {
      pageTitle: { required },
      pageSubtitle: { required },
      emailAddressPlaceholder: { required },
      questionPlaceholder: { required },
      topBannerImageBackgroundId: { required },
    }
  },
  computed: {
    ...mapGetters(['getSettings', 'getImgUrl']),
    speakersPageSettings () {
      return path(['speakersSetting'], this.getSettings)
    },
    topBannerImageUrl () {
      return this.topBannerChangedUrl || this.getImgUrl
    }
  },
  watch: {
    speakersPageSettings () {
      this.setFormData()
    }
  },
  methods: {
    ...mapActions([
      'fetchGeneralSettings',
      'updateSpeakersPageSettings',
      'setImageUrl'
    ]),
    toggleModal () {
      this.modalGallery = !this.modalGallery
    },
    resetImage () {
      this.formData.topBannerImageBackgroundId = ''
    },
    setImage (item) {
      this.formData.topBannerImageBackgroundId = item.id
      this.topBannerChangedUrl = item.imagesUrls.originalImageUrl
      this.toggleModal()
    },
    setFormData () {
      this.formData = clone(this.speakersPageSettings)
      this.setImageUrl(path(['topBannerImageBackgroundId'], this.formData))
    },
    submitForm () {
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.updateSpeakersPageSettings(this.formData)
    }
  },
  async created () {
    await this.fetchGeneralSettings()
    this.setFormData()
  }
}
</script>

<style lang="scss" scoped>
.input,
.headline {
  max-width: 480px;
}

.input:first-child {
  margin-right: 40px;
}

.form {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.headline {
  margin-bottom: 20px;
  text-align: center;
}

.card {
  padding: 10px;
  margin-bottom: 15px;
}

.btn {
  &_submit {
    margin: 0 auto;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Speakers/PageSettings/index.vue